import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm$entity$fromOrderD, _vm$entity$fromPoData, _vm$entity$fromOrderD2, _vm$entity$fromOrderD3, _vm$entity$creationCo;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.isAddingNewEntity ? "New stock part" : "Stock part"))])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_vm.isLoading ? _c("div", {
    staticClass: "text-center"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  })], 1) : [!_vm.isAddingNewEntity && _vm.entity ? [_c("div", {
    staticClass: "text-smaller"
  }, [_c("div", {
    staticClass: "mb-3"
  }, [_c("div", {
    staticStyle: {
      "font-size": "1.4em"
    }
  }, [_vm._v(" Quantity available : "), _c("span", {
    staticClass: "text-bigger text-bold"
  }, [_vm._v(_vm._s(_vm.entity.quantityAvailable))]), _vm.isEditable && !_vm.isAnyActionInProgress && !_vm.isAnySubformInProgress ? _c(VIcon, {
    staticClass: "fa fa-pen icon-link ml-2",
    staticStyle: {
      top: "-3px"
    },
    attrs: {
      size: "0.8em"
    },
    on: {
      click: _vm.startEditQty
    }
  }) : _vm._e()], 1), _vm.entity.status === _vm.STOCK_PART.STATUS.PRESELL.id ? _c("div", [_c("span", {
    staticClass: "badge --padding warning"
  }, [_vm._v("#PRE-ARRIVAL")])]) : _vm._e(), _vm.updatingQty.isConfiguring ? _c("div", {
    staticClass: "subform-bordered"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.updatingQty.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.updatingQty.form, "valid", $$v);
      },
      expression: "updatingQty.form.valid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      type: "number",
      label: "Quantity available, number of bottles",
      placeholder: "Number of bottles",
      min: 0,
      rules: [_vm.formRules.mustBeIntNotNegative],
      "hide-details": "auto"
    },
    on: {
      keypress: _vm.filterIntegerKey
    },
    model: {
      value: _vm.updatingQty.form.quantityAvailable,
      callback: function callback($$v) {
        _vm.$set(_vm.updatingQty.form, "quantityAvailable", $$v);
      },
      expression: "updatingQty.form.quantityAvailable"
    }
  }), _c(VTextarea, {
    staticClass: "required",
    attrs: {
      label: "Quantity adjustement reason(s)",
      rules: [_vm.formRules.mustNotBeEmpty],
      rows: "3",
      "hide-details": "auto"
    },
    model: {
      value: _vm.updatingQty.form.movementReason,
      callback: function callback($$v) {
        _vm.$set(_vm.updatingQty.form, "movementReason", $$v);
      },
      expression: "updatingQty.form.movementReason"
    }
  }), _c("div", {
    staticClass: "flex items-center mt-2 text-smaller"
  }, [_c(VSwitch, {
    staticClass: "mt-0 pt-0",
    attrs: {
      "hide-details": "auto"
    },
    model: {
      value: _vm.updatingQty.form.isChangingQuantityInit,
      callback: function callback($$v) {
        _vm.$set(_vm.updatingQty.form, "isChangingQuantityInit", $$v);
      },
      expression: "updatingQty.form.isChangingQuantityInit"
    }
  }), !_vm.updatingQty.form.isChangingQuantityInit ? _c("span", [_vm._v(" " + _vm._s(_vm.entity.quantityInit < +_vm.updatingQty.form.quantityAvailable ? "If necessary, the init/max quantity will increase to match the new available quantity" : "Will leave the init/max quantity at its current value : ".concat(_vm.entity.quantityInit)) + " ")]) : _c("span", [_vm._v(" Will increase/decrease init/max quantity with this new adjustment : " + _vm._s(_vm.entity.quantityInit - +_vm.entity.quantityAvailable + +_vm.updatingQty.form.quantityAvailable) + " ")])], 1), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      rounded: ""
    },
    on: {
      click: _vm.cancelUpdatingQty
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress || !_vm.updatingQty.form.valid || +_vm.updatingQty.form.quantityAvailable === +_vm.entity.quantityAvailable,
      loading: _vm.updatingQty.isPending
    },
    on: {
      click: _vm.saveUpdatingQty
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save quantity ")], 1)], 1), ((_vm$entity$fromOrderD = _vm.entity.fromOrderData) === null || _vm$entity$fromOrderD === void 0 ? void 0 : _vm$entity$fromOrderD.id) > 0 ? _c(VAlert, {
    attrs: {
      dense: "",
      outlined: "",
      type: "warning",
      color: "red",
      text: ""
    }
  }, [_vm._v(" Editing the quantity on stock created from an international stock transfer, which would have an associated invoice, may cause accounting issues. Please ensure that manually editing this quantity is absolutely necessary. Consider creating a credit note instead if possible. ")]) : _vm._e()], 1)], 1) : _vm._e()]), _c("div", {
    staticClass: "mb-3"
  }, [_vm._v(" Origin : "), ((_vm$entity$fromPoData = _vm.entity.fromPoData) === null || _vm$entity$fromPoData === void 0 ? void 0 : _vm$entity$fromPoData.id) > 0 ? [_c("router-link", {
    staticClass: "router-link",
    attrs: {
      to: _vm.goToPurchaseOrder(_vm.entity.fromPoData.id),
      target: "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.entity.fromPoData.reference ? "Po:".concat(_vm.entity.fromPoData.reference) : "Po#".concat(_vm.entity.fromPoData.id)) + " ")]), _vm.entity.fromPoData.actualDeliveryDate ? _c("span", [_vm._v(" , Receipt:" + _vm._s(_vm._f("formatDate")(_vm.entity.fromPoData.actualDeliveryDate)) + " ")]) : _vm._e()] : ((_vm$entity$fromOrderD2 = _vm.entity.fromOrderData) === null || _vm$entity$fromOrderD2 === void 0 ? void 0 : _vm$entity$fromOrderD2.id) > 0 ? [_c("router-link", {
    staticClass: "router-link",
    attrs: {
      to: _vm.goToOrder(_vm.entity.fromOrderData.id),
      target: "_blank"
    }
  }, [_vm._v(" " + _vm._s((_vm$entity$fromOrderD3 = _vm.entity.fromOrderData.invoiceNumberLabel) !== null && _vm$entity$fromOrderD3 !== void 0 ? _vm$entity$fromOrderD3 : _vm.entity.fromOrderData.referenceOrder.shorterReference()) + " ")]), _vm.entity.fromOrderData.deliveryDate ? _c("span", [_vm._v(" , Delivered:" + _vm._s(_vm._f("formatDate")(_vm.entity.fromOrderData.deliveryDate)) + " ")]) : _vm._e()] : _vm.entity.fromFirstInit ? [_vm._v(" first initialisation "), _vm.isEditable && !_vm.isAnyActionInProgress && !_vm.isAnySubformInProgress ? _c(VIcon, {
    staticClass: "fa fa-pen icon-link ml-1",
    attrs: {
      size: "0.85em"
    },
    on: {
      click: _vm.startDefineOrderOrigin
    }
  }) : _vm._e()] : [_vm._v("manual adjustment")]], 2), _vm.definingOrderOrigin.isConfiguring ? _c("div", {
    staticClass: "subform-bordered"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.definingOrderOrigin.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.definingOrderOrigin.form, "valid", $$v);
      },
      expression: "definingOrderOrigin.form.valid"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.addingEntity.compatibleOrderItems.length === 0 || _vm.isAnyActionInProgress,
      label: _vm.addingEntity.compatibleOrderItems.length === 0 ? "No order seems compatible with this stock" : "Transfer from order",
      items: _vm.addingEntity.compatibleOrderItems,
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      "item-text": "text",
      "item-value": "orderId",
      rules: [_vm.formRules.mustSelectValue],
      "hide-details": "auto"
    },
    model: {
      value: _vm.definingOrderOrigin.form.fromOrderId,
      callback: function callback($$v) {
        _vm.$set(_vm.definingOrderOrigin.form, "fromOrderId", $$v);
      },
      expression: "definingOrderOrigin.form.fromOrderId"
    }
  }), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      rounded: ""
    },
    on: {
      click: _vm.cancelDefineOrderOrigin
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress || !_vm.definingOrderOrigin.form.valid,
      loading: _vm.definingOrderOrigin.isPending
    },
    on: {
      click: _vm.confirmDefineOrderOrigin
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save origin ")], 1)], 1)], 1)], 1) : _vm._e(), true ? _c("div") : _vm._e(), _c("div", {
    staticClass: "mb-3"
  }, [_c("div", [_c("div", [_vm._v(" Purchase unit price "), _vm.isEditable && !_vm.isAnyActionInProgress && !_vm.isAnySubformInProgress ? _c(VIcon, {
    staticClass: "fa fa-pen icon-link ml-1",
    attrs: {
      size: "0.85em"
    },
    on: {
      click: _vm.startEditPurchasePrice
    }
  }) : _vm._e(), _vm.isEditable && !_vm.isAnyActionInProgress && !_vm.isAnySubformInProgress && !!_vm.entity.purchaseUnitPriceEuroExVat ? _c(VIcon, {
    staticClass: "fa fa-ban icon-link ml-2",
    attrs: {
      size: "0.85em",
      title: "Remove purchase price"
    },
    on: {
      click: _vm.confirmRemovePurchasePrice
    }
  }) : _vm._e()], 1), !_vm.handlingPurchasePrice.updating.isConfiguring ? _c("div", [_vm.entity.purchaseUnitPriceEuroExVat ? _c("span", {
    staticClass: "text-bigger"
  }, [_vm._v(" " + _vm._s(_vm.entity.purchaseUnitPriceEuroExVat) + " "), _c("span", {
    staticClass: "text-smaller"
  }, [_vm._v(" € "), _c("span", {
    staticStyle: {
      "font-size": "0.75em"
    }
  }, [_vm._v("excl.vat")])])]) : _c("span", {
    staticClass: "text-italic"
  }, [_vm._v(" Always cogs defined on the product page ")])]) : _vm._e()]), _vm.handlingPurchasePrice.updating.isConfiguring ? _c("div", {
    staticClass: "subform-bordered"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.handlingPurchasePrice.updating.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.handlingPurchasePrice.updating.form, "valid", $$v);
      },
      expression: "handlingPurchasePrice.updating.form.valid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      type: "number",
      label: "Purchase unit price (€ excl.vat)",
      placeholder: "0.00",
      min: 0,
      rules: [_vm.formRules.mustBeGreaterThan0],
      "hide-details": "auto"
    },
    on: {
      keypress: _vm.filterDecimalKey
    },
    model: {
      value: _vm.handlingPurchasePrice.updating.form.purchaseUnitPriceEuroExVat,
      callback: function callback($$v) {
        _vm.$set(_vm.handlingPurchasePrice.updating.form, "purchaseUnitPriceEuroExVat", $$v);
      },
      expression: "handlingPurchasePrice.updating.form.purchaseUnitPriceEuroExVat"
    }
  }), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      rounded: ""
    },
    on: {
      click: _vm.cancelUpdatingPurchasePrice
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress || !_vm.handlingPurchasePrice.updating.form.valid || +_vm.handlingPurchasePrice.updating.form.purchaseUnitPriceEuroExVat === +_vm.entity.purchaseUnitPriceEuroExVat,
      loading: _vm.handlingPurchasePrice.updating.isPending
    },
    on: {
      click: _vm.saveUpdatingPurchasePrice
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save purchase price ")], 1)], 1)], 1)], 1) : _vm._e()]), _c("div", {
    staticClass: "mb-3"
  }, [_vm._v(" Initial/Max quantity : "), _c("span", {
    staticClass: "text-bigger"
  }, [_vm._v(_vm._s(_vm.entity.quantityInit))])]), _c("div", [_vm._v(" Comment "), _vm.isEditable && !_vm.isAnyActionInProgress && !_vm.isAnySubformInProgress ? _c(VIcon, {
    staticClass: "fa fa-pen icon-link ml-1",
    attrs: {
      size: "0.85em"
    },
    on: {
      click: _vm.startEditComment
    }
  }) : _vm._e(), _vm.isEditable && !_vm.isAnyActionInProgress && !_vm.isAnySubformInProgress && !!_vm.entity.creationComment ? _c(VIcon, {
    staticClass: "fa fa-ban icon-link ml-2",
    attrs: {
      size: "0.85em",
      title: "Remove comment"
    },
    on: {
      click: _vm.confirmRemoveComment
    }
  }) : _vm._e()], 1), !_vm.handlingComment.updating.isConfiguring ? [((_vm$entity$creationCo = _vm.entity.creationComment) === null || _vm$entity$creationCo === void 0 ? void 0 : _vm$entity$creationCo.length) > 0 ? _c("div", {
    staticClass: "text-quote text-bigger",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.entity.creationComment))
    }
  }) : _c("div", {
    staticClass: "text-italic"
  }, [_vm._v("No comment defined")])] : _vm._e(), _vm.handlingComment.updating.isConfiguring ? _c("div", [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.handlingComment.updating.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.handlingComment.updating.form, "valid", $$v);
      },
      expression: "handlingComment.updating.form.valid"
    }
  }, [_c(VTextarea, {
    staticClass: "required",
    attrs: {
      label: "Comment",
      rows: "3",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.handlingComment.updating.form.creationComment,
      callback: function callback($$v) {
        _vm.$set(_vm.handlingComment.updating.form, "creationComment", $$v);
      },
      expression: "handlingComment.updating.form.creationComment"
    }
  }), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: _vm.cancelUpdatingComment
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress || !_vm.handlingComment.updating.form.valid,
      loading: _vm.handlingComment.updating.isPending
    },
    on: {
      click: _vm.saveComment
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save comment ")], 1)], 1)], 1)], 1) : _vm._e()], 2)] : _vm.isAddingNewEntity ? [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.addingEntity.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "valid", $$v);
      },
      expression: "addingEntity.form.valid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      type: "number",
      label: "Quantity available, number of bottles",
      placeholder: "Number of bottles",
      min: 1,
      rules: [_vm.formRules.mustBeGreaterThan0],
      "hide-details": "auto"
    },
    on: {
      keypress: _vm.filterIntegerKey
    },
    model: {
      value: _vm.addingEntity.form.quantityAvailable,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "quantityAvailable", $$v);
      },
      expression: "addingEntity.form.quantityAvailable"
    }
  }), _c(VTextarea, {
    staticClass: "required",
    attrs: {
      label: "Creation reason(s)",
      rows: "3",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.addingEntity.form.creationComment,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "creationComment", $$v);
      },
      expression: "addingEntity.form.creationComment"
    }
  }), _c(VAutocomplete, {
    attrs: {
      disabled: _vm.addingEntity.compatibleOrderItems.length === 0,
      label: "Transfer from order",
      items: _vm.addingEntity.compatibleOrderItems,
      "hide-no-data": "",
      "hide-selected": "",
      clearable: "",
      "item-text": "text",
      "item-value": "orderId",
      "hide-details": "auto"
    },
    model: {
      value: _vm.addingEntity.form.orderId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "orderId", $$v);
      },
      expression: "addingEntity.form.orderId"
    }
  }), _c(VTextField, {
    attrs: {
      type: "number",
      label: "Purchase unit price (€ excl.vat)",
      placeholder: "",
      min: 0,
      rules: [_vm.formRules.mustBeGreaterThan0OrEmpty],
      "hide-details": "auto"
    },
    on: {
      keypress: _vm.filterDecimalKey
    },
    model: {
      value: _vm.addingEntity.form.purchaseUnitPriceEuroExVat,
      callback: function callback($$v) {
        _vm.$set(_vm.addingEntity.form, "purchaseUnitPriceEuroExVat", $$v);
      },
      expression: "addingEntity.form.purchaseUnitPriceEuroExVat"
    }
  })], 1)] : _vm._e()], _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_vm.isEmptyable ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || _vm.isAnySubformInProgress,
      loading: _vm.emptyingStockPart.isPending
    },
    on: {
      click: function click($event) {
        return _vm.confirmEmptyingPart();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-ban mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Empty stock part ")], 1) : _vm._e(), !_vm.isLoading && _vm.isAddingNewEntity ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || !_vm.addingEntity.form.valid,
      loading: _vm.addingEntity.isPending
    },
    on: {
      click: function click($event) {
        return _vm.saveNewEntity();
      }
    }
  }, [_vm._v(" Save new part ")]) : _vm._e()], 1)], 2)], 1)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };